import React, { useEffect, useState } from 'react';
import { t } from 'i18next';
import { format } from 'date-fns';
import PropTypes from 'prop-types';
import {
  Circle,
  Container,
  DateLabel,
  Filler,
  Hour,
  Line,
  Location,
  LocationAndStatus,
  MapContainer,
  Status,
  TouchPoint,
  TrackingHistory,
} from './css';
import GoogleMap from '../GoogleMap';

const Tracking = ({ data, orderId }) => {
  const [points, setPoints] = useState([]);
  const [markers, setMarkers] = useState(null);
  const [selectedTouchPoint, setSelectedTouchPoint] = useState();
  const [selectedMarker, setSelectedMarker] = useState();
  const events = data;

  const onTouchPointClick = (e, id) => {
    if (e && e.preventDefault) {
      e.preventDefault();
    }

    const obj = points.filter((point) => point.id === id)[0];
    const coordsAreValid = (obj.coords && !(obj.coords.latitude === 0 && obj.coords.longitude === 0));
    setSelectedTouchPoint(obj.id);
    setSelectedMarker((coordsAreValid) ? obj.id : null);
  };

  useEffect(() => {
    const mapPoints = [];
    events.forEach((item) => {
      item.touchPoints.forEach((point) => {
        const idx = `${item.id}-${point.id}`;
        mapPoints.push({ ...point, id: idx, event: item.id });
      });
    });

    setPoints(mapPoints);
    if (mapPoints.length > 0) {
      setSelectedTouchPoint(mapPoints[0].id);
    }
  }, []);

  useEffect(() => {
    const mapMarkers = [];
    if (points) {
      points.forEach((item) => {
        const {
          coords, postalCode, id, statusCode,
        } = item;

        if ((coords && !(coords.latitude === 0 && coords.longitude === 0)) || postalCode) {
          mapMarkers.push({
            ...coords,
            id,
            order: orderId,
            status: statusCode,
            onClick: (e) => onTouchPointClick(e, id),
            selected: id === selectedTouchPoint,
            postalCode,
          });
        }
      });
    }

    setMarkers(mapMarkers);
  }, [selectedTouchPoint]);

  const showAllMarkersOnView = (selectedTouchPoint !== selectedMarker);

  const eventsToShow = events && events.length > 0 && events.reduce((acc, cur) => {
    const eventPoints = cur.touchPoints.length;
    const positionPoints = cur.touchPoints.filter((p) => p.statusCode === 'POSITION').length;
    return (eventPoints === positionPoints) ? acc : [...acc, cur];
  }, []);

  const filteredPoints = points.filter((point) => point.statusCode !== 'POSITION');

  // Render Area
  if (points.length === 0) {
    return null;
  }

  return (
    <Container>
      <TrackingHistory>
        {eventsToShow && eventsToShow.map((event, eventIndex) => {
          const isLastEvent = eventIndex === eventsToShow.length - 1;
          const eventPoints = filteredPoints.filter((point) => point.event === event.id);
          return (
            <React.Fragment key={event.id}>
              <DateLabel>{event.date ? format(event.date, t('WEEK_DATE_FORMAT_PATTERN')) : ''}</DateLabel>
              {eventPoints.map((touchPoint, index) => {
                const isLastTouchPoint = index === eventPoints.length - 1;
                const isExceptionStatus = (/^Exception - Call Customer Service$/i.test(touchPoint.status)
                  || /^Exception - Appeler le service à la clientèle/i.test(touchPoint.status)
                  || /^Exception - OSD/i.test(touchPoint.status)
                  || /^Livré - OSD/i.test(touchPoint.status))
                  && touchPoint.statusCode === 'COMPLETE';
                const displayStatus = isExceptionStatus ? t('ExceptionStatus') : touchPoint.status;
                return (
                  <TouchPoint key={touchPoint.id} selected={touchPoint.id === selectedTouchPoint}>
                    {eventIndex === 0
                      ? index === 0 && <Filler />
                      : index === 0 && <Line row={1} />}
                    <Hour>{touchPoint.time ? format(touchPoint.time, t('TIME_FORMAT_PATTERN')) : ''}</Hour>
                    <Circle />
                    <LocationAndStatus onClick={(e) => onTouchPointClick(e, touchPoint.id)}>
                      <Status>{displayStatus}</Status>
                      {!isExceptionStatus && touchPoint.location
                      && (
                        <Location>
                          {touchPoint.city}
                        </Location>
                      )}
                    </LocationAndStatus>
                    {(!isLastEvent || !isLastTouchPoint)
                      && (
                        <>
                          <Line row={3} />
                          <Line row={4} />
                        </>
                      )}
                  </TouchPoint>
                );
              })}
            </React.Fragment>
          );
        })}
      </TrackingHistory>
      <MapContainer>
        <GoogleMap mapid="google-map-0" markersList={markers} selectedPoint={selectedMarker} showAll={showAllMarkersOnView} />
      </MapContainer>
    </Container>
  );
};

Tracking.propTypes = {
  data: PropTypes.array,
  orderId: PropTypes.any,
};

export default Tracking;
